module.exports = __webpack_public_path__ + "img/IMG_3382.f242ae75.jpg";